export const Constants = {
    projectCategoryUsage: "beanspruchung",
    projectCategoryCreation: "neuschaffung",
    usageProjectTableName: "USAGE_PROJECT",
    creationProjectTableName: "CREATION_PROJECT",
    creationAreaExtTableName: "CREATION_AREA_EXT",
    compensationTableName: "COMPENSATION",
    contactTypeConstructionSupervisor: "baubegleitung",
    contactTypeContact: "contact",
    contactTypeOwner: "eigner/in",
    departmentRawi: "rawi",
    departmentUwe: "uwe",
    projectTypeConstructionPermit: "baubewilligung",
    projectTypeLandUsePlanChange: "nutzungsplanaenderung",
    projectTypeLandfillSite: "deponie",
    projectTypeSoilImprovement: "bodenverbesserung",
    projectTypeDezoning: "auszonung",
    projectTypeRecultivation: "rekultivierung",
    timestampFormat: "DD.MM.YYYY HH:mm",
    dateFormat: "DD.MM.YYYY",
    underCompensationThreshold: 0.0,
    overcompensationThreshold: 0.0,
};
